/*!
 * devextreme-angular
 * Version: 26.1.5
 * Build date: Fri Sep 11 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import type { HorizontalAlignment, VerticalAlignment } from 'devextreme/common';

import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-date-box-my',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoDateBoxMyComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get x(): HorizontalAlignment {
        return this._getOption('x');
    }
    set x(value: HorizontalAlignment) {
        this._setOption('x', value);
    }

    @Input()
    get y(): VerticalAlignment {
        return this._getOption('y');
    }
    set y(value: VerticalAlignment) {
        this._setOption('y', value);
    }


    protected get _optionPath() {
        return 'my';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoDateBoxMyComponent
  ],
  exports: [
    DxoDateBoxMyComponent
  ],
})
export class DxoDateBoxMyModule { }
